import cadex, { Base_Uuid } from '@cadexchanger/web-toolkit'
import { Dispatch, RefObject, SetStateAction } from 'react'

export type CADExViewerProps = {
  itemId: string
  partyId: string
  projectId: string
  is2DModel?: boolean
}

export const MeasurementType = {
  Dimension: 'measurements/dimensions',
  Angle: 'measurements/angle',
}

/* Context Types */

export type CadExProviderProps = {
  children?: JSX.Element[] | JSX.Element
  reference: RefObject<HTMLDivElement>
} & CADExViewerProps

export type SceneElementsContext = {
  model: cadex.ModelData_Model
  scene: cadex.ModelPrs_Scene
  viewPort: cadex.ModelPrs_ViewPort
  treeModel: Map<Base_Uuid, ModelNode>
  setModel?: Dispatch<SetStateAction<cadex.ModelData_Model>>
  setScene?: Dispatch<SetStateAction<cadex.ModelPrs_Scene>>
  setViewPort?: Dispatch<SetStateAction<cadex.ModelPrs_ViewPort>>
  setTreeModel?: Dispatch<SetStateAction<Map<Base_Uuid, ModelNode>>>
  load?: () => void
}

export type CadExContextReturn = {
  useSceneElements?: () => SceneElementsContext
  getContext?: () => SceneElementsContext
  setContext?: (props: SceneElementsContext) => void
}

/* END - Context Types */

/* hooks Types */

export type ModelLoadedDataReturn = {
  hasBRepRep: boolean
  polyRepCount: number
  roots: cadex.ModelData_SceneGraphElement[]
}

export type UseSceneElementsProps = {
  dataLoader: (modelName: string, subFile: string) => Promise<ArrayBuffer>
  reference: RefObject<HTMLDivElement>
  modelName: string
}

/* END - hooks Types */

export type ModelNode = {
  id: cadex.Base_Uuid
  view3dObject?: cadex.ModelPrs_View3dObject | cadex.ModelPrs_View3dObject[]
  level: number
  selected?: boolean
  text: string
  parent?: cadex.Base_Uuid
  type: string
  data?: {
    sge:
      | cadex.ModelData_Part
      | cadex.ModelData_Instance
      | cadex.ModelData_Assembly
  }
}
